'use client';

import { LogParams } from '~/apis/log';

import { useSendLog } from '~/hooks';
import useDeepCompareEffect from '~/hooks/useDeepCompareEffect';

type Props = {
  params: LogParams;
};
export const LogVisit = ({ params }: Props) => {
  const sendLog = useSendLog();

  useDeepCompareEffect(() => {
    if (!params) return;
    sendLog({
      ...params,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return null;
};
